import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SparkProfileT, SparkStateT } from "shared/types/spark";

export const initialState: SparkStateT = {
  items: [],
  uploaded: false,
  send: false,
  error: false,
};

const sparkSlice = createSlice({
  name: "spark",
  initialState,
  reducers: {
    clearFeed: () => {
      return {
        ...initialState,
      };
    },
    setSparkFeed: (state, { payload }: PayloadAction<SparkProfileT[]>) => {
      return {
        ...state,
        items: payload,
        uploaded: true,
        send: false,
      };
    },
    setAdditionalSparkFeed: (
      state,
      { payload }: PayloadAction<SparkProfileT[]>
    ) => {
      const merged = [...state.items, ...payload];

      const unique = merged.filter(
        (profile, index, self) =>
          index === self.findIndex((p) => p.uid === profile.uid)
      );

      return {
        ...state,
        items: unique,
        uploaded: true,
        send: false,
      };
    },
    markLikedUser: (state, { payload }: PayloadAction<number>) => {
      state.items = state.items.map((user) =>
        user.uid === payload ? { ...user, isLiked: true } : user
      );
    },
    toggleSend: (state, { payload }: PayloadAction<boolean>) => {
      state.send = payload;
    },
    removeUser: (state, { payload }: PayloadAction<number>) => {
      state.items = state.items.filter((user) => user.uid !== payload);
    },
    responseErrorFeed: (state) => {
      return {
        ...state,
        send: false,
        error: true,
      };
    },
  },
});

export const {
  clearFeed,
  removeUser,
  setSparkFeed,
  setAdditionalSparkFeed,
  toggleSend,
  responseErrorFeed,
  markLikedUser,
} = sparkSlice.actions;

export default sparkSlice.reducer;
